export default {
  user: localStorage.user === undefined ? null : JSON.parse(localStorage.user),
  current_unity: localStorage.user === undefined ? null : JSON.parse(localStorage.user).unity,
  accounts: [],
  auth_methods: [{ id: 1, name: 'Autenticação Interna' }, { id: 2, name: 'Autenticação Via SIGA' }],
}
